<section class="panel h1-a1-ma1-md0">
    <section class="header-zone">
        <ng-content select="[header-zone]"></ng-content>
    </section>
    <section class="actions-zone">
        <ng-content select="[actions-zone]"></ng-content>
    </section>
    <section class="data-zone with-actions">
        <ng-content select="[data-zone]"></ng-content>
    </section>
</section>
